<template>
  <qc-container v-if="goods" title="商品编辑" show-divider show-return>
    <el-form ref="goodsForm" :model="goods"  label-width="120px">
      <h4 class="form-title">商品信息</h4>
      <form-item-rule label="商品标题" prop="name">
        {{goods.name}}
      </form-item-rule>
      <form-item-rule label="商品编码" prop="codes">
        {{goods.codes}}
      </form-item-rule>
      <form-item-rule label="商品品牌" prop="brandId">
        {{goods.brandName}}
      </form-item-rule>
      <form-item-rule label="商品分类" prop="classifyId">
        {{goods.classifyName}}
      </form-item-rule>
      <el-form-item label="商品图片" prop="pictureList">
        <div class="picture-box">
          <div class="pb-item" v-for="pictureItem in pictureList">
            <el-image style="width: 120px; height: 120px" :src="pictureItem" :preview-src-list="pictureList">
            </el-image>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="商品库存" v-if="goodsStock">
        <div class="attribute-talbe">
          <el-table :data="sockList" :span-method="arraySpanMethod" border style="width: 100%">
            <el-table-column v-for="(title,titleIndex) in stockTitle" :label="title">
              <template #default="scope">
                {{ sockList && sockList[scope.$index] && sockList[scope.$index] && sockList[scope.$index].list && sockList[scope.$index].list[titleIndex] && sockList[scope.$index].list[titleIndex].name }}
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType!=1" label="销售价格（元）" width="180">
              <template #default="scope">
                <span>{{scope.row.salesPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" label="租用价格（元）" width="180">
              <template #default="scope">
                <span>{{scope.row.marketPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType!=1" label="销售库存" width="180">
              <template #default="scope">
                <span>{{scope.row.inventory}}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" label="租赁库存" width="180">
              <template #default="scope">
                <span>{{scope.row.marketInventory}}</span>
              </template>
            </el-table-column>
            <el-table-column label="重量（kg）" width="180">
              <template #default="scope">
                <span>{{scope.row.weight}}</span>
              </template>
            </el-table-column>
            <!--            <el-table-column prop="sales" label="销量" width="180"></el-table-column>-->
          </el-table>
        </div>
      </el-form-item>
      <template v-if="attributeList.length===0">
        <form-item-rule label="销售价格" v-if="goods.storeGoodsType!=1" prop="salesPrice">
          {{goods.salesPrice}}
        </form-item-rule>
        <form-item-rule v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" label="租用价格" prop="marketPrice">
          {{goods.marketPrice}}
        </form-item-rule>
        <form-item-rule label="销售库存" v-if="goods.storeGoodsType!=1" prop="inventory" >
          {{goods.inventory}}
        </form-item-rule>
        <form-item-rule label="租赁库存" v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" prop="marketInventory" >
          {{goods.marketInventory}}
        </form-item-rule>
        <form-item-rule label="重量(kg)" prop="weight">
          {{goods.weight}}
        </form-item-rule>
      </template>
      <form-item-rule label="商品原价" v-if="goods.storeGoodsType!=1" prop="salesPrice">
        {{goods.price}}
      </form-item-rule>
      <form-item-rule label="租赁押金" v-if="goods.storeGoodsType==1 || goods.storeGoodsType==2" prop="integralNum">
        {{goods.integralNum}}
      </form-item-rule>
      <el-form-item label="商品详情" prop="goodsDetails">
        <div class="goods-detail">
          <div v-if="goods.goodsDetails" v-html="goods.goodsDetails"></div>
        </div>
      </el-form-item>
      <form-item-rule label="运费模板" v-if="goods.storeGoodsType!=1">
        {{goods.templateName}}
      </form-item-rule>


      <template v-if="goods.applyStatus==0">
        <form-item-rule label="审核">
          <el-radio-group v-model="auditDetail.applyStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </form-item-rule>
        <form-item-rule label="意见">
          <el-input type="textarea" style="width: 500px;" :rows="4" placeholder="请输入审核意见" v-model="auditDetail.errorMsg">
          </el-input>
        </form-item-rule>
        <el-form-item >
          <el-button @click="returnLast">返回</el-button>
          <el-button type="primary" @click="auditSave">保存</el-button>
        </el-form-item>
      </template>
      <template v-else>
        <form-item-rule label="审核">
          {{goods.applyStatus==1?"通过":"驳回"}}
        </form-item-rule>
        <form-item-rule label="意见">
          {{goods.errorMsg}}
        </form-item-rule>
        <el-form-item >
          <el-button @click="returnLast">返回</el-button>
        </el-form-item>
      </template>

    </el-form>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container";
import DraftingUploadImg from "@/components/upload/DraftingUploadImg";
import ClassifyDict from "@/components/dict/ClassifyDict";
import Ueditor from "@/components/base/ueditor";
import FormItemRule from "@/components/el/form-item-rule.vue";
import SimpleBtn from "@/components/base/simple-btn.vue";
import SimpleDict from "@/components/dict/SimpleDict.vue";


export default {
  name: "edit",
  components: {
    SimpleDict,
    SimpleBtn,
    FormItemRule,
    Ueditor, ClassifyDict, DraftingUploadImg, QcContainer
  },
  data() {
    return {
      auditDetail:{id:"",applyStatus:1,errorMsg:""},
      goods: {
        id: '',
        orgId: '',
        classifyId: '',
        brandId:'',
        picture: '',
        name: '',
        salesPrice: '',
        marketPrice: 0,
        weight: 1,
        codes: '',
        inventory: '',
        warningInventory: '',
        area: '440106',
        freight: '',
        enables: 1,
        state: 1,
        isAttribute: 0,
        goodsDetails: '',
        pictureList: [],
        attributeList: [],
        sockList: [],
        provinces: '',
        city: '',
        region: '',
        countryType: 0,
        country: "",
        exportStatus: 0,
        taxRateId: '',
        taxRatePrice: 0,
        goodsType:0,
        storeGoodsType:0
      },
      type: 0,
      isFreight: false,
      index: 0,
      addAttributeDialog: false,
      attribute: {name: ''},
      goodsStock: false,
      attributeList: [],
      pictureList: [],
      stockTitle: [],
      sockList: [],
      areaDesc: '广东省/广州市/天河区',
      batchDialog: false,
      batchType: 0,
      batchTitle: '',
      batchName: '',
      batchValue: '',
      taxRateOption: [],
      taxPateProps: {value: "id", label: "name", checkStrictly: true, emitPath: false},
      countryOption: [],
      templateList:[],
    }
  },
  methods: {
    returnLast: function () {
      history.back(-1);
    },
    //属性头部属性
    setStockTitle() {
      let newStockTitle = new Array();
      for (let i = 0, leg = this.attributeList.length; i < leg; i++) {
        newStockTitle.push(this.attributeList[i].name);
      }
      this.stockTitle = newStockTitle;
    },
    //组装tr
    setStockTr() {
      var num = 1;
      var list = this.attributeList;

      if (list.length > 0) {
        //获取总行数
        for (var i = 0, leng = list.length; i < leng; i++) {
          num = num * (list[i].dynamicTags.length);
        }
        //初始化数组
        this.sockList = [];
        //写入第一行
        this.firstList(this.attributeList[0].dynamicTags, num);

        //属性大于2
        if (this.attributeList.length > 2) {
          this.otherList(num);
        }
        if (this.attributeList.length > 1) {
          //写入最后一行
          this.lastList(this.attributeList[this.attributeList.length - 1].dynamicTags, num);
        }

      }
    },
    //获取第一行
    firstList(list, num) {
      //获取第一行循环次数
      let zNum = num / list.length;
      let cswz = 0;//位置
      for (let i = 0; i < list.length; i++) {
        for (let ni = 0; ni < zNum; ni++) {
          let state = false;
          if (ni == 0) {
            state = true;
          }
          let obj = {name: list[i], rowspan: zNum, queryKey: 1 + "" + (i + 1), state: state};
          this.sockList[cswz] = {
            list: [obj],
            salesPrice: '',
            marketPrice: '',
            inventory: '',
            codes: '',
            weight: 0,
            sales: 0
          };
          cswz++;
        }
      }
    },
    //写入其他行数
    otherList(num) {
      var list = this.attributeList;

      //写入除最后一行外所有数据
      for (var i = 1, leng = list.length; i < leng - 1; i++) {
        var key = (i + 1) + "";
        var dList = list[i].dynamicTags;//当前选项
        var xNum = list[i - 1].dynamicTags.length;//循环次数
        //获取循环次数
        var xNum = 1;
        for (var xi = (i - 1); xi >= 0; xi--) {
          xNum = xNum * (list[xi].dynamicTags.length);
        }
        //获取每个值占行数
        var xLeng = 1;
        for (var ri = (i + 1); ri < list.length; ri++) {
          xLeng = xLeng * list[ri].dynamicTags.length;
        }

        var cswz = 0;//初始化位置

        for (var xi = 0; xi < xNum; xi++) {
          for (var di = 0, dl = dList.length; di < dl; di++) {
            for (var hi = 0; hi < xLeng; hi++) {
              var obj = {name: dList[di], rowspan: xLeng, queryKey: key + (di + 1), state: false};
              if (hi == 0) {
                obj.state = true;
              }
              var osList = this.sockList[cswz].list;
              obj.queryKey = osList[osList.length - 1].queryKey + "-" + obj.queryKey;
              this.sockList[cswz].list.push(obj);
              cswz++;
            }
          }
        }
      }
    },
    //获取最后一行
    lastList(list, num) {
      //获取最后一行循环次数
      var key = this.attributeList.length + "";
      var zNum = num / list.length;
      var cswz = 0;
      for (var numi = 0; numi < zNum; numi++) {
        for (var listi = 0, leng = list.length; listi < leng; listi++) {
          var dList = this.sockList[cswz].list;
          var queryKey = dList[dList.length - 1].queryKey + "-" + key + (listi + 1);
          this.sockList[cswz].list.push({name: list[listi], rowspan: 1, queryKey: queryKey, state: true});
          cswz++;
        }
      }
    },

    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex < this.stockTitle.length) {
        let item = this.sockList[rowIndex].list[columnIndex];
        if (item.state) {
          return {
            rowspan: item.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    auditSave(){
      let data = this.auditDetail;
      if(data.applyStatus==2 && !data.errorMsg){
        this.$message({
          type:'warning',
          message: '请输入驳回原因!'
        });
        return;
      }

      data.id = this.goods.id;

      this.simplePost("/api/mgr/business/goods/authGoods", data, result => {
        this.message("操作成功");
        this.returnLast();
      })
    }
  },
  mounted() {

    if (this.$route.query && this.$route.query.id) {
      this.goods.id = this.$route.query.id;
      this.simpleGet("/api/mgr/shop/business/goods/detail", {id: this.goods.id}, result => {
        this.goods = result.data;

        if(result.data.storeGoodsType==3){
          this.goods.goodsType = 2;
        }

        let pictureList = [];
        if (this.goods.pictureList && this.goods.pictureList.length > 0) {
          this.goods.pictureList.forEach(row=>{
            pictureList.push(this.filePath + row.url);
          })
        }

        this.pictureList = pictureList;
        //设置地址
        this.areaDesc = result.data.areaDesc;

        //设置attributeList
        var goodsAttributeList = result.data.attributeList;
        if (goodsAttributeList.length > 0) {
          var attributeList = new Array();
          for (var i = 0; i < goodsAttributeList.length; i++) {
            var goodsAttribute = goodsAttributeList[i];
            var contentList = goodsAttribute.attributeContentList;
            var cList = new Array();
            for (var ci = 0; ci < contentList.length; ci++) {
              cList.push(contentList[ci].content);
            }
            attributeList.push({
              "name": goodsAttribute.name,
              "inputVisible": false,
              inputValue: "",
              "dynamicTags": cList
            });
          }
          this.goodsStock = true;
          this.attributeList = attributeList;
          this.setStockTitle();

          //设置sockList
          var sockList = new Array();
          var goodsAttributeDetailsList = result.data.sockList;

          for (var i = 0; i < goodsAttributeDetailsList.length; i++) {
            var goodsAttributeDetails = goodsAttributeDetailsList[i];
            sockList.push({
              "list": $.parseJSON(goodsAttributeDetails.listJson),
              "salesPrice": goodsAttributeDetails.salesPrice,
              "marketPrice": goodsAttributeDetails.marketPrice,
              "inventory": goodsAttributeDetails.inventory,
              "codes": goodsAttributeDetails.codes,
              "sales": goodsAttributeDetails.sales,
              "weight":goodsAttributeDetails.weight,
              "marketInventory":goodsAttributeDetails.marketInventory
            });
          }

          this.sockList = sockList;
        }

      });
    }
  }
}
</script>

<style lang="less" scoped>
.form-title {
  margin-left: 20px;
}

.el-form-item--small {
  margin-top: 10px;
}

.el-input--small {
  width: 215px;
}

.form-but {
  width: 1240px;
  padding: 20px;
  background-color: #FFFFFF;
  text-align: center;
  position: fixed;
  bottom: 0;
  _position: absolute;
  z-index: 2;
  overflow: hidden;
  margin: 0 auto;
}

.attribute-talbe{
  width: 100%;
}

.attribute-talbe table {
  background: #ffffff;
  width: 100%;
  border: 1px solid #E9E9E9;
  color: #333333;
  border-collapse: collapse;
}

.attribute-talbe table > tr > td {
  padding: 4px;
  border: 1px solid #f5f4f4;
}

.attribute-talbe table .tips {
  color: @primary;
}

.attribute-talbe table > tr > td > p, h5 {
  margin: 0px;
}

.attribute-talbe table .attribute-name {
  text-align: center;
  width: 10%;
}

.el-tag--small {
  height: 32px;
  line-height: 32px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.attribute-input {
  height: 32px;
  line-height: 32px;
}

.stock-table > tr > td {
  text-align: center;
}

.stock-table > tr > td .width-100 {
  width: 100px;
}

.price-input {
  width: 80px;
}

.batch-but {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  background: #FFFFFF;
}


.picture-box{
  display: flex;
  flex-wrap: wrap;

  .pb-item{
    margin-right: 10px;
  }
}

.goods-detail{
  height: 500px;
  overflow: auto;
}
</style>
